module.exports = __webpack_public_path__ + "static/media/Admin-10.dfc686d1.png";